import { render, staticRenderFns } from "./ibox3.vue?vue&type=template&id=165efb63&"
import script from "./ibox3.vue?vue&type=script&lang=js&"
export * from "./ibox3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('165efb63')) {
      api.createRecord('165efb63', component.options)
    } else {
      api.reload('165efb63', component.options)
    }
    module.hot.accept("./ibox3.vue?vue&type=template&id=165efb63&", function () {
      api.rerender('165efb63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/widgets/ibox3.vue"
export default component.exports